import React from "react";
import { Alert, Card, ListGroup } from "react-bootstrap";

import { useAppCollection } from "../../api/firestoreWrappers.generated";
import { ResultListGroupItems } from "../ResultListGroupItems";

export const isFilePublished = (file, isAdmin) => isAdmin || !!file.published;

export const hasPublishedFiles = (files, isAdmin) =>
    files.some((file) => isFilePublished(file, isAdmin));

export const hasUnpublishedFiles = (files) =>
    files.some((file) => !isFilePublished(file, false));

export default function ResultsList({
    resultsByDateAndApp,
    isAdmin,
    showOrganizationName,
    organizationMap,
    showLocationName,
    locationMap,
    extraDropdownItems,
    showFile = (file, isAdmin) => isFilePublished(file, isAdmin),
}) {
    const [allApps] = useAppCollection([], { type: "map" });

    return (
        <>
            {Object.keys(resultsByDateAndApp).length === 0 && (
                <Alert variant="primary" className="mb-4">
                    No results found
                </Alert>
            )}
            {Object.keys(resultsByDateAndApp)
                .sort()
                .reverse()
                .map((date) => {
                    const resultsOnDate = resultsByDateAndApp[date];
                    const totalFilesOnDate = Object.values(resultsOnDate)
                        .flat()
                        .reduce((sum, result) => {
                            const visibleFiles = (result.files ?? []).filter(
                                (file) => showFile(file, isAdmin),
                            );
                            return sum + visibleFiles.length;
                        }, 0);

                    return (
                        <Card key={date} className="mb-4">
                            <Card.Header className="px-4 d-flex justify-content-between align-items-start">
                                <div>
                                    <b>{date}</b>
                                </div>
                                <div className="text-muted">
                                    <small>{totalFilesOnDate} files</small>
                                </div>
                            </Card.Header>
                            <ListGroup variant="flush" className="p-0">
                                {Object.keys(resultsOnDate)
                                    .sort((a, b) => {
                                        const nameA = allApps[a]?.name ?? "";
                                        const nameB = allApps[b]?.name ?? "";
                                        return nameA.localeCompare(nameB);
                                    })
                                    .map((appId) => {
                                        const results = resultsOnDate[appId];

                                        return (
                                            <React.Fragment key={appId}>
                                                <ListGroup.Item className="fw-bold small text-muted px-4 mt-1 pb-0">
                                                    {allApps[appId]?.name}
                                                </ListGroup.Item>

                                                <ResultListGroupItems
                                                    className={"py-1 px-4"}
                                                    results={results}
                                                    isAdmin={isAdmin}
                                                    showOrganizationName={
                                                        showOrganizationName
                                                    }
                                                    organizationMap={
                                                        organizationMap
                                                    }
                                                    showLocationName={
                                                        showLocationName
                                                    }
                                                    locationMap={locationMap}
                                                    extraDropdownItems={
                                                        extraDropdownItems
                                                    }
                                                />
                                            </React.Fragment>
                                        );
                                    })}
                            </ListGroup>
                        </Card>
                    );
                })}
        </>
    );
}
